<template>
  <ai-tool-tip
    role="alert"
    align-item="center"
    variant="inProcess"
    :label="
      $t('booking.tooltip.inProcess', { minutes: timerDuration.inMinutes })
    " />
</template>

<script setup lang="ts">
import { useRefreshPricesDuration } from '../../hooks/useRefreshPricesDuration';

const timerDuration = useRefreshPricesDuration();
</script>
